module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr.",
  "Prof. Dr."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/name/prefix.js
 ** module id = 347
 ** module chunks = 0
 **/